// CardVisitas.jsx
import React from 'react';
import style from './CardVisitaAll.module.css';
import { Link } from 'react-router-dom';

const CardVisitaAll = ({ visita }) => {
  const isExterna = visita.tipo === 'externa';

  const getInteresLabel = (interes) => {
    if (!interes) return null;
    if (interes.yes) return { text: 'Le interesa', className: style.interesYes };
    if (interes.no) return { text: 'No le interesa', className: style.interesNo };
    if (interes.maybe) return { text: 'Quizás', className: style.interesMaybe };
    return null;
  };

  return (
    <div className={`${style.card} ${isExterna ? style.cardExterna : ''}`}>
      {isExterna && <span className={style.badgeExterna}>EXTERNA</span>}
      <h3>Visitante: {visita.visitante}</h3>
      <p><strong>Agente:</strong> {visita.agente}</p>
      <p><strong>Fecha:</strong> {visita.fecha}</p>

      {isExterna ? (
        <>
          <p><strong>Dirección:</strong> {visita.direccion}</p>
          {visita.localidad && <p><strong>Localidad:</strong> {visita.localidad}{visita.provincia ? `, ${visita.provincia}` : ''}</p>}
          {visita.inmobiliariaExterna && <p><strong>Inmobiliaria:</strong> {visita.inmobiliariaExterna}</p>}
          {visita.tipoPropiedad && <p><strong>Tipo:</strong> {visita.tipoPropiedad}</p>}
          {visita.precio && <p><strong>Precio:</strong> {visita.moneda || ''} {visita.precio}</p>}
          {visita.descripcion && <p><strong>Descripción:</strong> {visita.descripcion}</p>}
          {visita.observaciones && <p><strong>Observaciones:</strong> {visita.observaciones}</p>}
          {(() => {
            const interes = getInteresLabel(visita.interes);
            return interes ? <p><strong>Interés:</strong> <span className={interes.className}>{interes.text}</span></p> : null;
          })()}
          {visita.client && (
            <p><strong>Cliente:</strong> {visita.client.nombre} {visita.client.apellido}</p>
          )}
        </>
      ) : (
        <>
          <p><strong>Descripción:</strong> {visita.descripcion}</p>
          <div className={style.containerButtons}>
            <Link to={`https://byraices.com/detail/${visita.propertyId}`} target="_blank" rel="noopener noreferrer" className={style.detailsLink}>
              <button className={style.detailsButton}>Link de propiedad</button>
            </Link>
            <Link to={`https://redbyraices.com/historial/visitas/${visita.propertyId}`} target="_blank" rel="noopener noreferrer" className={style.detailsLink}>
              <button className={style.detailsButton}>Estadistica de la propiedad</button>
            </Link>
          </div>
        </>
      )}
    </div>
  );
};

export default CardVisitaAll;
